import { render } from "./OtherWeaponsBoard.vue?vue&type=template&id=768b3f18"
import script from "./OtherWeaponsBoard.vue?vue&type=script&lang=js"
export * from "./OtherWeaponsBoard.vue?vue&type=script&lang=js"

import "./OtherWeaponsBoard.vue?vue&type=style&index=0&id=768b3f18&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__